// extracted by mini-css-extract-plugin
export default {"afterPayModeSection":"o7-z","refreshPageWarning":"p7-z","redirectMessageText":"q7-z"};